import {createSlice, current} from "@reduxjs/toolkit";
import {produce} from "immer";

export const extranetSlice = createSlice({
    name: 'extranet',
    initialState: {
        perimetersV2: {},
        selectedContrat: null,
        selectedCompany: null,
        selectedCodeCompany: null,
        selectedPerimeter: null
    },
    reducers: {
        setPerimetersV2: (state, action) => {
            if (action.payload) {
                return produce(current(state), draft => {
                    draft.perimetersV2 = action.payload;
                    const keys = Object.keys(action.payload);
                    draft.selectedContrat = keys[0];
                    console.log(action.payload[keys[0]][0])
                    draft.selectedCompany = action.payload[keys[0]][0]['id']
                    draft.selectedCodeCompany = action.payload[keys[0]][0]['codeEntreprise']
                    /*if (action.payload.length === 1) {
                        draft.selectedPerimeter = action.payload[0];
                    }*/
                })
            }
        },
        selectPerimeter: (state, action) => {
            if (action.payload) {
                return produce(current(state), draft => {
                    draft.selectedPerimeter = action.payload;
                })
            }
        },
        selectContrat: (state, action) => {
            if (action.payload) {
                return produce(current(state), draft => {
                    draft.selectedContrat = action.payload;
                })
            }
        },
        selectCompany: (state, action) => {
            if (action.payload) {
                return produce(current(state), draft => {
                    draft.selectedCompany = action.payload;
                })
            }
        },
        selectCodeCompany: (state, action) => {
            if (action.payload) {
                return produce(current(state), draft => {
                    draft.selectedCodeCompany = action.payload;
                })
            }
        },
    }
})

export const {
    selectCodeCompany,
    selectCompany,
    selectContrat,
    setPerimetersV2,
    selectPerimeter
} = extranetSlice.actions

export default extranetSlice.reducer
